// extracted by mini-css-extract-plugin
module.exports = {"container":"MaxWidthContainer_container__yvTu7"};